import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
type ProjectCardProps = {
  id: string;
  title: string;
  category: string;
  description: string;
  imageUrl: string;
};
const ProjectCard = ({
  id,
  title,
  category,
  description,
  imageUrl
}: ProjectCardProps) => {
  return <Link to={`/projects/${id}`} className="block group" data-id="element-154">
      <div className="relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300" data-id="element-155">
        <div className="aspect-w-16 aspect-h-10 w-full h-64" data-id="element-156">
          <img src={imageUrl} alt={title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" data-id="element-157" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6" data-id="element-158">
          <span className="text-sm font-medium text-[#95c11f] mb-1" data-id="element-159">
            {category}
          </span>
          <h3 className="text-xl font-bold text-white mb-2" data-id="element-160">{title}</h3>
          <p className="text-gray-200 line-clamp-2" data-id="element-161">{description}</p>
        </div>
      </div>
    </Link>;
};
export default ProjectCard;